import Settings from 'containers/Settings'

export default Settings
